import {
  Button,
  Menu,
  MenuItemRadio,
  MenuList,
  MenuPopover,
  MenuTrigger,
  makeStyles,
  tokens,
} from "@fluentui/react-components";
import { LocalLanguageRegular } from "@fluentui/react-icons";
import { useAtom } from "jotai";
import { useTranslation } from "react-i18next";

import { getLanguages, type SupportedLanguage } from "@/i18n/config";
import { cultureAtom } from "@/store";

const useStyles = makeStyles({
  menuItem: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
  },
  nativeName: {
    color: tokens.colorNeutralForeground3,
  },
});

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const [culture, setCulture] = useAtom(cultureAtom);
  const styles = useStyles();

  const handleLanguageChange = (
    _event: unknown,
    data: { checkedItems: string[] },
  ) => {
    const langCode = data.checkedItems[0] as SupportedLanguage | undefined;

    if (!langCode || langCode === culture) {
      return;
    }

    void i18n.changeLanguage(langCode);
    setCulture(langCode);
    localStorage.setItem("priorityOSLng", langCode);
  };

  const languages = getLanguages();
  const currentLanguage = languages.find(
    (language) => language.code === culture,
  );

  return (
    <Menu
      checkedValues={{ language: [culture] }}
      onCheckedValueChange={handleLanguageChange}
    >
      <MenuTrigger disableButtonEnhancement>
        <Button
          appearance="subtle"
          icon={<LocalLanguageRegular />}
          aria-label={t("language")}
        >
          {currentLanguage?.nativeName ?? "English"}
        </Button>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          {languages.map((language) => (
            <MenuItemRadio
              key={language.code}
              name="language"
              value={language.code}
            >
              <span className={styles.menuItem}>
                <span>{language.nativeName}</span>
                <span className={styles.nativeName}>({language.name})</span>
              </span>
            </MenuItemRadio>
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
}
